import { MesfModal } from "@dexteel/mesf-core";
import { Button, Grid2 as Grid } from "@mui/material";
type Props = {
	label: string;
	show: boolean;
	onHide: (proceed: boolean) => void;
	existingName: string;
};
export const ConfirmModal = ({ label, show, onHide, existingName }: Props) => {
	return (
		<>
			<MesfModal
				title="CONFIRM"
				open={show}
				id="confirm-modal"
				handleClose={() => onHide(false)}
			>
				<MesfModal.Content style={{ padding: "15px 30px" }}>
					<Grid container spacing={1}>
						<Grid size={{ xs: 12, md: 12 }}>
							<p>{`A ${label} with the name '${existingName}' already exists. Do you want to proceed?`}</p>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid size={{ xs: 12, md: 3 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide(false)}
							>
								No
							</Button>
						</Grid>
						<Grid size={{ xs: 12, md: 3 }} style={{ margin: 0 }}>
							<Button
								fullWidth
								onClick={() => onHide(true)}
								variant="contained"
								color="primary"
								type="submit"
							>
								Yes
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</>
	);
};
